<script>

    import { toast } from 'bulma-toast'
    import { tipsStore, modalStore } from '../stores'

    import TipsService from '../$services/tips.service'

    import Form from '../$components/form.svelte'
    import Textarea from '../$components/textarea.svelte'
    import Button from '../$components/button.svelte'
    import Select from '../$components/select.svelte'

    let loading = false
    let data = {}

    async function createTip() {
    
        loading = true
        const resp = await TipsService.createTip(data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        tipsStore.append(resp.data, -1)
        modalStore.close()

        toast({message: 'Tip creado', type: 'is-success'})
    }

</script>

<Form on:submit={createTip} { loading } >
    <div class="columns">
        <div class="column">
            <Select
                bind:value={data.type}
                label="Tipo"
                options={[
                    {value: 'Tip de la plataforma', text: 'Tip de la plataforma'},
                    {value: 'Dato curioso', text: 'Dato curioso'},
                    {value: 'Nota importante', text: 'Nota importante'},
                ]}
            />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Textarea bind:value={data.message} label="Mensaje" placeholder="Ingrese el mensaje" />
        </div>
    </div>
    <div class="items-end">
        <div class="buttons">
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light"/>
            <Button type="submit" text="Guardar" icon="save" color="primary" {loading}/>
        </div>
    </div>
</Form>